import React, { PureComponent } from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import { booleanConvert } from '../helpers';

export class EditableTableRow extends PureComponent {
    state = {
        isBeingEdited: this.props.data.Id === "new" 
    }

    componentWillMount() {
        const { rowId, rows, data } = this.props;
        const newState = {};

        for (let i = 0, n = rows.length; i < n; i++) {
            const rowInfo = rows[i];
            newState[rowId + "_" + rowInfo.id] = data[rowInfo.id]
        }

        this.setState(newState);
    }

    editRow = (e, v) => {
        this.setState({ isBeingEdited: true });
        this.props.onEdit();
    }

    saveRow = (e, v) => {
        const objectToSend = {
            Id: this.props.rowId.substring(this.props.rowId.lastIndexOf('_') + 1)
        };

        for (var key in this.state) {
            if (key.indexOf("_") > 0) {
                objectToSend[key.substring(key.lastIndexOf('_') + 1)] = this.state[key];
            }
        }

        this.cancelEditRow();
        this.props.saveRow(objectToSend);
    }

    deleteRow = () => {
        const id = this.props.rowId.substring(this.props.rowId.lastIndexOf('_') + 1)

        this.cancelEditRow();
        this.props.deleteRow(id);
    }

    cancelEditRow = (e) => {
        const id = this.props.data.Id;
        const newState = {
            isBeingEdited: false
        }

        if(id === "new"){
            this.props.deleteRow(id);
        }

        if(typeof e !== "undefined"){
            const row = e.target.closest(".tableRow");
            const inputs = row.querySelectorAll("input");
            const textareas = row.querySelectorAll("textarea");

            for(let i=0, n=inputs.length; i<n; i++){
                const el = inputs[i];
                newState[el.id] = el.dataset.originalval;
            }
    
            for(let i=0, n=textareas.length; i<n; i++){
                const el = textareas[i];
                newState[el.id] = el.dataset.originalval
            }
        }

        this.setState({...newState});
        this.props.onStopEdit();
    }

    onChange = (e) => {
        const el = e.target;
        this.setState({ [el.id]: el.value });
    }

    onChangeCheckbox = (e) => {
        const el = e.target;
        this.setState({ [el.id]: el.checked ? 1 : 0 });
    }

    render() {
        const { isBeingEdited } = this.state;
        const { data, rows, rowId, isAdmin, loginData, editing, tableLabel } = this.props;

        return (
            <TableRow className={"tableRow " + (isBeingEdited ? "editing" : "")}>
                {rows.map(rowInfo => rowInfo.type && 
                    <TableCell data-title={rowInfo.name} className={"tableCell" + (rowInfo.className ? " " + rowInfo.className.replace("Header", "Cell") : "")} key={rowId + "_" + rowInfo.id}>
                        {rowInfo.type === "checkbox" &&
                            <input
                                type={rowInfo.type}
                                disabled={!isBeingEdited}
                                id={rowId + "_" + rowInfo.id}
                                onChange={this.onChangeCheckbox}
                                checked={!!+this.state[rowId + "_" + rowInfo.id]}
                                data-originalval={!!+data[rowInfo.id]} />
                        }
                        {(rowInfo.type === "text" || rowInfo.type === "number") &&
                            <input
                                type={rowInfo.type}
                                disabled={!isBeingEdited}
                                id={rowId + "_" + rowInfo.id}
                                onChange={this.onChange}
                                value={rowInfo.numeric ? parseInt(this.state[rowId + "_" + rowInfo.id]) : this.state[rowId + "_" + rowInfo.id]}
                                data-originalval={data[rowInfo.id]} />
                        }
                        {rowInfo.type === "textarea" &&
                            <textarea
                                rows="2"
                                disabled={!isBeingEdited}
                                id={rowId + "_" + rowInfo.id}
                                onChange={this.onChange}
                                value={this.state[rowId + "_" + rowInfo.id]}
                                data-originalval={data[rowInfo.id]}>
                                    {this.state[rowId + "_" + rowInfo.id]}
                            </textarea>
                        }
                        {rowInfo.type === "checkbox" && <label>{booleanConvert(this.state[rowId + "_" + rowInfo.id])}</label>}
                    </TableCell>
                )}
                <TableCell data-title="Ações" className="tableCell actions">
                    {!isBeingEdited && (isAdmin || loginData.profile.Settings?.permission === 1) &&
                        <Tooltip
                            disableFocusListener={editing}
                            disableHoverListener={editing}
                            disableTouchListener={editing}
                            title={"Editar " + tableLabel}
                            enterDelay={200}>
                            <span><button disabled={editing} type="button" className="simpleBtn actionButton warning" onClick={this.editRow} ><i className="fa fa-pencil-alt"></i></button></span>
                        </Tooltip>
                    }
                    {isBeingEdited && (isAdmin || loginData.profile.Settings?.permission === 1) &&
                        <Tooltip
                            title={"Gravar " + tableLabel}
                            enterDelay={200}>
                            <span><button type="button" className="simpleBtn actionButton success" onClick={this.saveRow} ><i className="fa fa-check"></i></button></span>
                        </Tooltip>
                    }
                    {!isBeingEdited && (isAdmin || loginData.profile.Settings?.DEL) &&
                        <Tooltip
                            disableFocusListener={editing}
                            disableHoverListener={editing}
                            disableTouchListener={editing}
                            title={"Eliminar " + tableLabel}
                            enterDelay={200}>
                            <span><button disabled={editing} type="button" className="simpleBtn actionButton danger" onClick={this.deleteRow}><i className="fa fa-times"></i></button></span>
                        </Tooltip>
                    }
                    {isBeingEdited &&
                        <Tooltip
                            title={"Cancelar Edição"}
                            enterDelay={200}>
                            <span><button type="button" className="simpleBtn actionButton danger" onClick={this.cancelEditRow}><i className="fa fa-ban"></i></button></span>
                        </Tooltip>
                    }
                </TableCell>
            </TableRow>
        );
    }
}
